import { MainApp, MainAppOptions } from './main-app.js';
import { PassphraseHandler } from './passphrase-handler.js';

export type { MainAppOptions };

export async function registerView(input: MainAppOptions) {
  const passphraseHandler = await PassphraseHandler.fromApi();
  const mainView = new MainApp(input, passphraseHandler);
  if (mainView.salt) {
    mainView.showPassphraseForm();
  } else {
    mainView.showErrorDetails('Not Found', { disableReset: true });
  }
  window.addEventListener('error', error => {
    mainView.showErrorDetails(error.message);
  });
}
